export default "__VITE_ASSET__BGTItw3h__"